import React from 'react';
import { Nav } from 'rsuite';
import styled from 'styled-components';
import { getPlatformFriendlyName } from '../../../utils/string-utils';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const NavWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  margin-bottom: 19px;
  .rs-nav-subtle.rs-nav-horizontal .rs-nav-waterline {
    border-top: 2px solid rgba(8, 10, 37, 0.1);
  }
`;

const StyledNav = styled(Nav)`
  .rs-nav {
    font-size: 14px;
    font-weight: 600;
  }

  .rs-nav-item-content {
    font-weight: 600 !important;
    color: #101938;
  }

  .rs-nav-item-active > .rs-nav-item-content {
    color: #101938;

    :hover {
      color: #101938;
    }

    ::before {
      background-color: #101938 !important;
    }
  }
`;

const Waterline = styled.div`
  border-bottom: 2px solid rgba(8, 10, 37, 0.1);
  margin-top: 34px;
  max-width: 580px;
  width: 100%;
  /* margin-top: -2px; */
`;

const countListingsByPlatform = (listings, platformList) => {
  const counter = {};

  // initialization
  platformList.forEach((p) => {
    counter[p] = 0;
  });

  // counting
  listings.forEach((l) => {
    counter.all++;
    counter[l.platform]++;
  });

  return counter;
};

function Tabs(props) {
  const { platformList, platformIcons, listings } = props;

  const ALL = 'all';
  platformList.unshift(ALL);
  const counter = countListingsByPlatform(listings, platformList);

  return (
    <StyledNav
      appearance="subtle"
      onSelect={(value) => props.onSelect(value)}
      activeKey={props.activeTab}
    >
      {platformList.map((platform, i) => (
        <Nav.Item key={i} eventKey={platform}>
          {getPlatformFriendlyName(platform, platformIcons)} (
          {counter[platform]})
        </Nav.Item>
      ))}
    </StyledNav>
  );
}

/**
 * Displays tabs and other navigation buttons
 */
function Navigation(props) {
  return (
    <NavWrapper>
      <Tabs
        onSelect={props.onSelect}
        platformList={props.platformList}
        platformIcons={props.platformIcons}
        activeTab={props.activeTab}
        listings={props.listings}
      />
      <Waterline />
    </NavWrapper>
  );
}

export function RegistrationMod(props) {
  return (
    <Wrapper>
      <Navigation
        onSelect={props.onSelect}
        platformList={props.platformList}
        platformIcons={props.platformIcons}
        activeTab={props.activeTab}
        listings={props.listings}
      />
    </Wrapper>
  );
}
